export const componentsContextMixin = (superclass) =>
  class ComponentsContextMixinClass extends superclass {
    updateComponentsContext(componentsContext) {
      this.dispatchEvent(
        new CustomEvent('components-context', {
          bubbles: true,
          composed: true,
          detail: componentsContext,
        })
      );
    }
  };
